// Dealer-group values the client shares, so the chat composer, the conversation list and the brief card
// cannot drift apart on them. Which groups a person can USE is the store's usable_dealer_groups getter.

// The virtual "every store I can access" group. DealerGroupConstants.AllRooftopsGroupId server-side, which
// resolves it to the caller's accessible stores wherever a group is accepted.
export const ALL_ROOFTOPS_GROUP_ID = '__ALL__';
